import { ComputedRef } from '@vue/composition-api';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { setIsAlternativeRegistrationEnabled } from '@src/app/shared/featureFlags/isAlternativeRegistrationEnabled';
import { Route } from 'vue-router';

export async function getIsMojeIdEnabled(route: ComputedRef<Route>): Promise<boolean> {
    const isPresentMojeParam = route.value.query.moje !== undefined && route.value.query.moje !== 'false' || route.value.query.conversationId !== undefined;

    const isAlternativeRegistrationByParamEnabled = await featureFlagService.getFeatureValue(AccountFlagNames.isAlternativeRegistrationByParamEnabled, false);
    const isAlternativeRegistrationEnabled = await featureFlagService.getFeatureValue(AccountFlagNames.isAlternativeRegistrationEnabled, false);
    const isMojeIdEnabled = isAlternativeRegistrationByParamEnabled ? isAlternativeRegistrationEnabled && isPresentMojeParam : isAlternativeRegistrationEnabled;

    setIsAlternativeRegistrationEnabled(isMojeIdEnabled);

    return isMojeIdEnabled;
}
